// src/components/Confirmation.js
import React, { useEffect, useState, useContext, useRef } from "react";

import Footer from "./Footer";
import BackToTopButton from "./BackToTop";

//import "./conformpage.css";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import HeaderPayment from "./HeaderPayment";
import Breadcrumbs from "./Breadcrumbs";
import { dompurifyHtml } from "../utils/sanitizeInput";

const Faq = () => {
  const carrierContxt = useContext(CarrierContext);
  const mainFaqContentsReff = useRef(null);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setConfirmationCMS] = useState("");
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.faq) {
      setConfirmationCMS(cmsAllPages.faq);
    }
  }, [cmsAllPages, setConfirmationCMS]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mainFaqContentsReff.current) {
        mainFaqContentsReff.current.focus();
      }
    }, 1000); // Delay to ensure the DOM is fully rendered

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <>
      <div
        id="main-faq-contents"
        ref={mainFaqContentsReff}
        tabIndex="-1"
      >
        <div id={`header-${urlCarrier}`}>
          <HeaderPayment
            page="faq"
            setLangSelected={setLangSelected}
          ></HeaderPayment>
        </div>

        <main id="main" className="main">
          <div>
            <Breadcrumbs cms={cms}></Breadcrumbs>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: dompurifyHtml(cms?.faq_content),
            }}
          />
          <BackToTopButton></BackToTopButton>
        </main>

        

        <Footer cms={cms}></Footer>
      </div>
    </>
  );
};

export default Faq;
